import pathify from 'vuex-pathify'
export default pathify

// options
